<script setup lang="ts">
import { computed, h } from "vue";
import { useI18n } from "vue-i18n";

import { assigneeChipId, cardActions } from "@/action/cardActions";
import { cardKey } from "@/components/StickyNote/injectKeys";
import UserAvatar from "@/components/ui/UserAvatar/UserAvatar.vue";
import { useUser } from "@/composables/useUser";
import IconUser from "@/icons/persona/user.svg?component";
import { injectStrict } from "@/utils/vue";

import AttributeChip from "../AttributeChip.vue";
import UserTooltip from "./UserTooltip.vue";
import SetAssignee from "./internal/SetAssignee.vue";

const card = injectStrict(cardKey);

const { userName } = useUser();
const { t } = useI18n();

// TODO this logic here would be better in UserTooltip, but this causes a "i18n is not initialized" error
// I guess it's because tippy is executed very early
const shortcut = computed(() => cardActions.openAssigneeDropdown.data.shortcut.name());
const tooltip = computed(() => ({
  content: h(UserTooltip, {
    reporter:
      card.reporter && card.reporter.almMapping !== "alm-only"
        ? t("general.reporter", { name: userName(card.reporter) })
        : undefined,
    assignee: t("general.assigned", { name: userName(card.assignee, "") }),
    shortcut: card.assignee ? "" : shortcut.value,
  }),
}));
</script>

<template>
  <AttributeChip
    :id="assigneeChipId(card.id)"
    name="assignee-chip"
    :active="!!card.assignee"
    :tooltip
    :dropdown-props="{ width: 'auto' }"
  >
    <SetAssignee />
    <template #icon>
      <UserAvatar v-if="card.assignee" :user="card.assignee" size="small" neutral-color />
      <IconUser v-else />
    </template>
  </AttributeChip>
</template>
